import React, { useEffect, useState } from "react";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Spin,
  Tabs,
  message,
} from "antd";
import styled from "styled-components";
import { RightOutlined, SearchOutlined } from "@ant-design/icons";
import TabsList from "molecules/TabsList";
import { StyledTable } from "atoms/Table";
import { useHistory } from "react-router-dom";
import { ReactComponent as Editicon } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as TrashDelete } from "../../assets/Trash_Full.svg";
import { ReactComponent as TimerClock } from "../../assets/Timer_clock.svg";
import { ReactComponent as Trash } from "../../assets/icons/Deleted_Trash.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getEditPerformanceContract,
  getLocations,
  getMyTeamPerformanceList,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import { ManagingOffice } from "common/Constants";
import moment from "moment";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import {
  setEditPerformanceContract,
  setMyTeamPerformanceResponseViewList,
} from "redux/actions";
import { dateInDetail } from "utils/Date";
import { CALL_API } from "common/API";
import trashfull from "../../assets/Trash_Full.png";
import { STATUS_CODE } from "common/Constants";
import { uniqBy } from "lodash";
import PerformanceContract from "./PerformanceContract";

const Container = styled.div`
  .breadcrumb {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    color: #1f243b;
  }
  .performance-management {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
    cursor: pointer;
  }
  .right-icon {
    width: 10px;
    height: 10px;
    margin-bottom: 10px;
  }
  .content_two_box {
    background-color: rgb(250, 250, 250);
    padding: 18px 8px 8px 8px;
    border-radius: 16px;
    margin-bottom: 30px;
    margin-left: 20px;
  }
  .performance-content {
    display: flex;
  }
  .performance-label {
    font-size: 14px;
    font-family: sans-serif;
    font-weight: 200;
    text-align: left;
    flex: 1;
    color: rgb(138, 143, 160);
  }
  .performance-value {
    font-size: 14px;
    font-family: sans-serif;
    font-weight: 500;
    flex: 1;
  }
  .icon-agree {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 45px;
    cursor: pointer;
  }
  .icons_edit_delete {
    display: flex;
    gap: 40px;
    justify-content: flex-end; /* Align to the right side of the container */
  }
  .edit_icon {
    background-color: #c2fae5;
    color: black;
    cursor: pointer;
  }
  .delete_icon {
    background-color: #c2fae5;
    color: black;
    cursor: pointer;
  }
  .staff-agreed {
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    text-decoration: underline;
    color: #126df6;
  }
  .timer-line {
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    color: #636980;
  }
  .timer-paragraph {
    display: flex;
    flex-direction: column; /* Stack elements vertically */
    align-items: center; /* Center horizontally */
    justify-content: center; /* Center vertically */
    text-align: center;
  }
  .searchbar {
    width: 176px;
    height: 34px;
    border-radius: 24px;
    border: 1px solid #e2e2e8;
  }
`;

const CustomModalContent = styled.div`
  content-align: center;
  height: 50px;
  border-radius: 8px !important;
  background-color: white;
  text-align: center;
`;

const StyledModal = styled(Modal)`
  .delete-modal-text {
    font-weight: 400;
    font-size: 18px;
    color: #636980;
    border-radius: 8px !important;
  }
  .two-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 16px;
  }
  .no-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #1f243b;
    color: #1f243b;
    font-weight: 400;
    font-size: 16px;
  }
  .yes-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background: #c2fae5;
    border: 1px solid #c2fae5;
    font-weight: 400;
    font-size: 16px;
  }
  .tick-deleted {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .deleted-text {
    font-weight: 400;
    font-size: 18px;
  }
`;

const StyledAgreeModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
  }
`;

const EvaluatedResponse = () => {
  const { id } = useParams();
  console.log("id -->", id);
  const dispatch = useDispatch();
  const history = useHistory();
  const myteamperformancelist = useSelector(getMyTeamPerformanceList);
  const userList = useSelector(getUserList);
  const [activeTab, setActiveTab] = useState(1);
  const [staffAgreeActiveTab, setStaffAgreeActiveTab] = useState(1);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [isDeletedModal, setIsDeletedModal] = useState(false);
  const [form] = Form.useForm();
  const { confirm } = Modal;
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const userInfo = useSelector(getUserInfo);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [editPerformance, setEditPerformance] = useState(false);
  console.log("selectedRecord -->", selectedRecord);

  const editPerformanceContract = useSelector(getEditPerformanceContract);
  console.log("editPerformanceContract -->", editPerformanceContract);
  const getDetails = async () => {
    setLoading(true);
    const { appraisalList, code } = await CALL_API(
      `appraisal/myteam?userid=${userInfo?.userid}`,
      "get",
      {}
    );

    if (code === STATUS_CODE?.SUCCESS) {
      setDetails(appraisalList);
      setLoading(false);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  const deletedetails = async () => {
    // Show a confirmation modal before proceeding to delete
    confirm({
      title: (
        <span style={{ color: "#636980" }}>
          Are you sure you want to delete this performance contract?
        </span>
      ),
      okText: "Delete",
      cancelText: "Cancel",
      icon: null,
      centered: true,
      modalRender: (modal) => (
        <div
          style={{
            overflow: "hidden",
            borderRadius: "8px",
            width: "480px",
            color: "red !important",
          }}
        >
          {modal}
        </div>
      ),
      okButtonProps: {
        style: {
          width: "130px",
          height: "34px",
          borderRadius: "8px",
        },
      },
      cancelButtonProps: {
        style: {
          width: "130px",
          height: "34px",
          borderRadius: "8px",
        },
      },
      onOk: async () => {
        try {
          const response = await CALL_API(`appraisal/${id}`, "delete");

          if (response.code === "SUCCESS") {
            Modal.success({
              title: null,
              icon: (
                <CustomModalContent>
                  <img src={trashfull} alt="Trashfull Icon" />
                  <div
                    style={{
                      marginTop: "10px",
                      fontSize: "18px",
                    }}
                  >
                    Deleted
                  </div>
                </CustomModalContent>
              ),
              content: null,
              centered: true,
              okButtonProps: { style: { display: "none" } },
            });
            getDetails();
            setTimeout(() => {
              Modal.destroyAll();
              history.push("/performancemanagement", {
                tabId: "managerappraisal",
              });
            }, 2000);
          } else {
            message.error("Failed to delete the appraisal. Please try again.");
            getDetails();
          }
        } catch (error) {
          console.error("Error deleting record:", error);
          message.error("An error occurred while deleting the appraisal.");
        }
      },
      onCancel: () => {
        console.log("Delete action canceled");
      },
    });
  };
  const handleTabSelect = (key) => {
    setActiveTab(key);
  };

  const handleStaffAgreeTabSelect = (key) => {
    setStaffAgreeActiveTab(key);
  };

  const showDeleteModal = () => {
    setIsDeleteModal(true);
  };

  const handleOk = () => {
    setIsDeleteModal(false);
    setIsDeletedModal(true);
    setTimeout(() => {
      setIsDeletedModal(false);
      history.push("/performancemanagement");
    }, 2000);
  };

  const handleRowClick1 = (record) => {
    history.push(`/viewmytabledata/${record?.attendid}/${activeTab}/${id}`);
  };

  const handleCancel = () => {
    setIsDeleteModal(false);
  };

  const items = [
    {
      label: "New Response",
      id: 1,
    },
    {
      label: "Evaluated",
      id: 2,
    },
  ];

  const staffagreeditems = [
    {
      label: "Agreed",
      id: 1,
      children: <></>,
    },
    {
      label: "Yet to Agree",
      id: 2,
      children: <></>,
    },
  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "employeename",
      key: "employeename",
    },
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
    },
    {
      title: "Employment Type",
      dataIndex: "employeetype",
      key: "employeetype",
    },
    {
      title: "Location",
      dataIndex: "managingoffice",
      key: "managingoffice",
    },
  ];

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const agreecolumns = [
    { title: "Name", dataIndex: "employeename", key: "employeename" },
    { title: "Employee ID", dataIndex: "employeeid", key: "employeeid" },
    {
      title: "Employement Type",
      dataIndex: "employeetype",
      key: "employeetype",
    },
    { title: "Location", dataIndex: "managingoffice", key: "managingoffice" },
  ];

  if (staffAgreeActiveTab === 1) {
    agreecolumns.push({
      title: "Agreed On",
      dataIndex: "agreedon",
      key: "agreedon",
      render: (val) => {
        return `${moment(val)?.format("DD MMM YYYY") || "-"}`;
      },
    });
  }

  const { getPerformanceContractMyTeamResponseView } = queryKeys;
  const queryParams = new URLSearchParams();
  queryParams.append("contractid", id);
  const queryString = queryParams.toString();
  const { key, url } = getPerformanceContractMyTeamResponseView(queryString);
  const locationList = getLocations();

  const { data: PerformanceContractMyTeamResponseViewRes, isLoading } =
    useFetch(key, url, {
      enabled: true,
    });

  const myteamPerformanceResponseViewData =
    PerformanceContractMyTeamResponseViewRes?.response?.performanceContractList;

  useEffect(() => {
    dispatch(
      setMyTeamPerformanceResponseViewList(
        PerformanceContractMyTeamResponseViewRes?.response
          ?.performanceContractList
      )
    );
  }, [myteamPerformanceResponseViewData]);

  const newResponseData =
    myteamperformancelist?.filter(
      (item) => item?.contractid?.toString() === id
    ) || [];

  let responseViewData =
    myteamPerformanceResponseViewData?.filter((obj) =>
      obj.appraisarmailid.includes(userInfo?.userid)
    ) || [];

  let mergedList = (responseViewData ?? [])?.map((employee) => {
    let user = userList?.find(
      (user) => user?.userid === employee?.appraiseeemailid
    );
    return {
      ...employee,
      managingoffice: user?.managingoffice[0] || "-",
      employeeid: user?.employeeid || "-",
      employeename: user?.fullname || "-",
      jobtitle: user?.jobtitle || "-",
      employeetype: "Contract" || "-",
    };
  });

  let newResponseMergedList = mergedList.filter(
    (item) =>
      item?.reviewedby?.["Primary"] !== userInfo.userid &&
      item?.reviewedby?.["Additional 1"] !== userInfo.userid &&
      item?.reviewedby?.["Aditional 1"] !== userInfo.userid &&
      item?.reviewedby?.["Additional 2"] !== userInfo.userid &&
      item?.reviewedby?.["Aditional 2"] !== userInfo.userid &&
      item?.reviewedby?.["Additional 3"] !== userInfo.userid &&
      item?.reviewedby?.["Aditional 3"] !== userInfo.userid
  );

  let evaluatedMergedList = mergedList.filter(
    (item) =>
      item?.reviewedby?.["Primary"] === userInfo.userid ||
      item?.reviewedby?.["Additional 1"] === userInfo.userid ||
      item?.reviewedby?.["Aditional 1"] === userInfo.userid ||
      item?.reviewedby?.["Additional 2"] === userInfo.userid ||
      item?.reviewedby?.["Aditional 2"] === userInfo.userid ||
      item?.reviewedby?.["Additional 3"] === userInfo.userid ||
      item?.reviewedby?.["Aditional 3"] === userInfo.userid
  );

  let staffAgreeMergedList = (
    newResponseData?.[0]?.individual_appraisals ?? []
  ).map((employee) => {
    let user = userList?.find(
      (user) => user?.userid === employee?.apraiseemailid
    );

    return {
      ...employee,
      managingoffice: user?.managingoffice?.[0] || "-",
      employeeid: user?.employeeid || "-",
      employeename: user?.fullname || "-",
      jobtitle: user?.jobtitle || "-",
      employeetype: "Contract",
    };
  });

  const handleFilter = (data) => {
    const employeeName = data?.type || [];
    const country = data?.country || [];

    return newResponseMergedList?.filter((item) => {
      const employeeNameMatch =
        employeeName.length > 0
          ? employeeName.includes(item.employeename)
          : true;
      const countryMatch =
        country.length > 0
          ? country.some((c) => item.location.includes(c))
          : true;

      return employeeNameMatch && countryMatch;
    });
  };

  const handleFormChange = () => {
    const values = form.getFieldsValue();
    setFilteredData(handleFilter(values));
  };

  useEffect(() => {
    setFilteredData(newResponseMergedList);
  }, [myteamPerformanceResponseViewData]);

  function countAgreedAppraisals(contract) {
    if (Array.isArray(contract?.individual_appraisals)) {
      return contract.individual_appraisals.filter(
        (appraisal) => appraisal?.agreestatus === "Agree"
      )?.length;
    }
    return 0;
  }
  const agreedCount = countAgreedAppraisals(newResponseData[0]);

  return (
    <>
      {!editPerformance && (
        <>
          <Container>
            <Row gutter={[16, 16]}>
              <Col xl={12} sm={24}>
                <div className="breadcrumb">
                  <p
                    className="performance-management"
                    onClick={() =>
                      history.push(`/performancemanagement`, { tabId: "2" })
                    }
                  >
                    Performance Management
                  </p>
                  <RightOutlined className="right-icon" />
                  <p>{newResponseData[0]?.performancecontractname || "-"}</p>
                </div>
              </Col>
            </Row>
          </Container>
          <Container>
            <Row className="content_two_box" gutter={[16, 16]}>
              <Col xl={8}>
                <div className="performance-content">
                  <p className="performance-label">Performance</p>
                  <p className="performance-value">
                    {newResponseData[0]?.performancecontractname || "-"}
                  </p>
                </div>
                <div className="performance-content">
                  <p className="performance-label">Start Date</p>
                  <p className="performance-value">
                    {moment(newResponseData[0]?.submissionstartdate)?.format(
                      "DD MMM YYYY"
                    ) || "-"}
                  </p>
                </div>
                <div className="performance-content">
                  <p className="performance-label">Location</p>
                  <p className="performance-value">
                    {newResponseData[0]?.location
                      ?.filter((loc) => loc)
                      ?.join(", ") || "-"}
                  </p>
                </div>
              </Col>
              <Col xl={4}></Col>
              <Col xl={6}>
                <div>
                  <div className="performance-content">
                    <p className="performance-label">Type</p>
                    <p className="performance-value">
                      {newResponseData[0]?.type || "-"}
                    </p>
                  </div>
                  <div className="performance-content">
                    <p className="performance-label">Due</p>
                    <p className="performance-value">
                      {moment(newResponseData[0]?.submissionenddate)?.format(
                        "DD MMM YYYY"
                      ) || "-"}
                    </p>
                  </div>
                  <div className="performance-content">
                    <p className="performance-label">Preferred Appraisees</p>
                    <p className="performance-value">
                      {newResponseData[0]?.individual_appraisals?.length || 0}
                    </p>
                  </div>
                </div>
              </Col>
              <Col xl={4}>
                <div className="icon-agree">
                  <div className="icons_edit_delete">
                    {(() => {
                      const hasPrimaryRole =
                        newResponseData[0]?.individual_appraisals?.some(
                          (appraisal) =>
                            appraisal?.appraisarmailid?.some(
                              (email, index) =>
                                email === userInfo?.userid &&
                                appraisal?.appraiseeroletype?.[index] ===
                                  "Primary"
                            )
                        );

                      return hasPrimaryRole ? (
                        <>
                          {newResponseData[0]?.agreestatuscount === 0 && (
                            <Editicon
                              name="edit"
                              className="edit_icon"
                              onClick={() => {
                                console.log("Edit icon clicked");
                                setSelectedRecord(
                                  newResponseData[0]?.contractid
                                );
                                // dispatch(setEditPerformanceContract(true));
                                setEditPerformance(true);
                              }}
                            />
                            // <Editicon
                            //   name="edit"
                            //   className="edit_icon"
                            //   onClick={() => {
                            //     // history.push("/PerformanceContract", {
                            //     //   isEditing: true,
                            //     //   selectedRecord: newResponseData[0]?.contractid,
                            //     //   activeTab: 2,
                            //     //   // editData: newResponseData[0],
                            //     //   // appraiseeData:
                            //     //   //   newResponseData[0]?.individual_appraisals || [], // Pass appraisee data
                            //     //   // fromEvaluatedResponse: true,
                            //     // });
                            //     setEditPerformance(true);
                            //   }}
                            // />
                          )}
                          <TrashDelete
                            onClick={() => deletedetails()}
                            name="delete"
                            className="delete_icon"
                          />
                        </>
                      ) : (
                        ""
                      );
                    })()}
                  </div>
                  <div
                    className="staff-agreed"
                    onClick={() => setIsModalVisible(true)}
                  >
                    Staff Agreed: {agreedCount}
                  </div>
                  <StyledAgreeModal
                    open={isModalVisible}
                    onCancel={() => setIsModalVisible(false)}
                    width={800}
                    footer={null}
                  >
                    <Row gutter={16}>
                      <Col xl={24} xs={24}>
                        <Space>
                          <TabsList
                            items={staffagreeditems}
                            tabId={staffAgreeActiveTab}
                            handleTabSelect={handleStaffAgreeTabSelect}
                          />
                        </Space>
                      </Col>
                    </Row>
                    <Row gutter={12} className="g-3 mb-2">
                      <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                        <p>
                          Total People:{" "}
                          {staffAgreeActiveTab === 1
                            ? staffAgreeMergedList?.filter(
                                (item) => item?.agreestatus === "Agree"
                              )?.length
                            : staffAgreeMergedList?.filter(
                                (item) => item?.agreestatus === "Yet to Agree"
                              )?.length}
                        </p>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12} xl={12} />{" "}
                      {/* Empty column to push search to the end */}
                      <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                        <DropdownCheckBox
                          name="name"
                          label="Search"
                          options={uniqBy(
                            newResponseMergedList.map((val) => ({
                              label: val.employeename,
                              value: val.employeename,
                            })),
                            "value"
                          )}
                          form={form}
                          handleFormChange={handleFormChange}
                        />
                      </Col>
                    </Row>

                    <StyledTable
                      columns={agreecolumns}
                      dataSource={
                        staffAgreeActiveTab === 1
                          ? staffAgreeMergedList?.filter(
                              (item) => item?.agreestatus === "Agree"
                            )
                          : staffAgreeMergedList?.filter(
                              (item) => item?.agreestatus === "Yet to Agree"
                            )
                      }
                      pagination={false}
                    />
                  </StyledAgreeModal>
                </div>
              </Col>
            </Row>
          </Container>
          <Container>
            <Row gutter={16}>
              <Col xl={24} xs={24}>
                <Space>
                  <TabsList
                    items={items}
                    activeTab={activeTab}
                    handleTabSelect={handleTabSelect}
                  />
                </Space>
              </Col>
            </Row>
          </Container>
          <Spin spinning={isLoading}>
            <Container>
              {((activeTab === 1 && newResponseMergedList?.length !== 0) ||
                (activeTab === 2 && evaluatedMergedList?.length !== 0)) && (
                <Row gutter={16}>
                  <Col sm={24} lg={12}>
                    <p className="mt-2">
                      {" "}
                      Total People:{" "}
                      {activeTab === 1
                        ? newResponseMergedList?.length
                        : evaluatedMergedList?.length}
                    </p>
                  </Col>
                  <Col sm={24} lg={12}>
                    <Form
                      form={form}
                      layout="vertical"
                      onValuesChange={handleFormChange}
                    >
                      <Row gutter={12} className="g-3 mb-2">
                        <Col xs={24} sm={24} md={12} lg={8} xl={12}>
                          <DropdownCheckBox
                            name="name"
                            label="Search"
                            options={uniqBy(
                              newResponseMergedList.map((val) => ({
                                label: val.employeename,
                                value: val.employeename,
                              })),
                              "value"
                            )}
                            form={form}
                            handleFormChange={handleFormChange}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={8} xl={12}>
                          <DropdownCheckBox
                            name="country"
                            label="Location"
                            options={uniqBy(
                              newResponseMergedList
                                .filter(
                                  (val) =>
                                    Array.isArray(val.location) &&
                                    val.location.length > 0
                                ) // Ensure location is a non-empty array
                                .map((val) => ({
                                  label: val.location.join(", "), // Convert array to a comma-separated string
                                  value: val.location.join(", "),
                                })),
                              "value"
                            )}
                            form={form}
                            handleFormChange={handleFormChange}
                          />
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>
              )}
            </Container>
            <Container>
              {activeTab === 1 && (
                <>
                  {newResponseMergedList?.length === 0 ? (
                    <Container>
                      <div className="timer-paragraph">
                        <TimerClock />
                        <p className="timer-line">
                          {moment().isBefore(
                            moment(newResponseData[0]?.submissionstartdate)
                          ) ? (
                            <>
                              Appraisees have not started their contract <br />
                              yet, as the start date has not arrived for them.
                            </>
                          ) : (
                            "Appraisees have not started their contract"
                          )}
                        </p>
                      </div>
                    </Container>
                  ) : (
                    <Row className="mb-3 mt-0" gutter={[16, 16]}>
                      <Col xl={24} sm={24}>
                        <div>
                          <StyledTable
                            columns={columns}
                            dataSource={filteredData}
                            pagination={false}
                            onRow={(record) => ({
                              onClick: () => handleRowClick1(record),
                              style: { cursor: "pointer" },
                            })}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}
                </>
              )}
              {activeTab === 2 && (
                <>
                  {evaluatedMergedList?.length === 0 ? (
                    <Container>
                      <div className="timer-paragraph">
                        <TimerClock />
                        <p className="timer-line">
                          {moment().isBefore(
                            moment(newResponseData[0]?.submissionstartdate)
                          ) ? (
                            <>
                              Appraisees have not started their contract <br />
                              yet, as the start date has not arrived for them.
                            </>
                          ) : (
                            "No Data"
                          )}
                        </p>
                      </div>
                    </Container>
                  ) : (
                    <Row className="mb-3 mt-0" gutter={[16, 16]}>
                      <Col xl={24} sm={24}>
                        <div className="mb-3 mt-0">
                          <StyledTable
                            columns={columns}
                            dataSource={evaluatedMergedList}
                            pagination={false}
                            onRow={(record) => ({
                              onClick: () => handleRowClick1(record),
                            })}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}
                </>
              )}
            </Container>
          </Spin>
          <StyledModal
            width={470}
            height={170}
            open={isDeleteModal}
            footer={null}
            onCancel={handleCancel}
            closable={false}
            style={{ marginTop: "100px" }}
          >
            <p className="delete-modal-text">
              Are you sure you want to delete this performance contract?
            </p>
            <div className="two-buttons">
              <Button className="no-modal-button" onClick={handleCancel}>
                No
              </Button>
              <Button className="yes-modal-button" onClick={handleOk}>
                Yes
              </Button>
            </div>
          </StyledModal>
          <StyledModal
            width={200}
            height={100}
            open={isDeletedModal}
            footer={null}
            closable={false}
            style={{
              marginTop: "120px",
            }}
          >
            <div className="tick-deleted">
              <Trash />
              <p className="deleted-text">Deleted</p>
            </div>
          </StyledModal>
        </>
      )}

      {editPerformance && (
        <>
          <div className="breadcrumb">
            <p
              className="performance-management1 mb-0"
              onClick={() => {
                setEditPerformance(false);
                history.push(`/performancemanagement`, { tabId: "2" });
              }}
            >
              Performance Management
            </p>
            <RightOutlined className="mt-0 pt-0 mx-2" />
            <p className="mb-0">Editing Performance</p>
          </div>
          <PerformanceContract
            isEditing={selectedRecord}
            setEditPerformance={setEditPerformance}
            editData={selectedRecord}
            selectedRecord={selectedRecord}
            setActiveKey={setActiveTab}
          />
        </>
      )}
    </>
  );
};

export default EvaluatedResponse;
